import React, { useEffect, useState } from "react";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, InsertDateFormat } from "utils/Constant";
import { ApiGetDailyTransaction } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import { money } from "utils/helpers";
import moment from "moment";
import DatePicker from "components/Input/DatePicker";
import HideIcon from "assets/icon/HideIcon";
import ShowIcon from "assets/icon/ShowIcon";
import SearchButton from "components/Button/SearchButton";

export default function DailyTransactionReport(){
    const { data: transactionList, fetch: getTransactionList } = useFetch(ApiGetDailyTransaction)

    const [dateFrom, setDateFrom] = useState(new Date())
    const [dateTo, setDateTo] = useState(new Date())
    const [showSalesDetail, setShowSalesDetail] = useState(false)
    const [isToggled, setIsToggled] = useState(false)
    
    const handleToggle = () => {
        setIsToggled(prev => !prev)
    }
    const dateFromChange = (e) => {
        if (e === null) {
            setDateFrom(new Date())
        }else{
            setDateFrom(e)
        }
    }
    const dateToChange = (e) => {
        if (e === null) {
            setDateTo(new Date())
        }else{
            setDateTo(e)
        }
    }
    const showSalesDetailClick = () => {
        setShowSalesDetail(!showSalesDetail)
    }
    const searchBtnClick = () => {
        setLoading({isOpen: true})
        
        fGetTransactionList(dateFrom, dateTo).then(() => {
            setLoading({isOpen: false})
        })
    }

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        setLoading({isOpen: true})

        fGetTransactionList(dateFrom, dateTo).then(() => {
            setLoading({isOpen: false})
        })
    },[isToggled])

    // Function Api Call
    async function fGetTransactionList(dateFrom, dateTo){
        await getTransactionList({
            data: {
                dateFrom: moment(dateFrom).format(InsertDateFormat),
                dateTo: moment(dateTo).format(InsertDateFormat),
                showCustomerExeption: isToggled,
                edcId: EmptyString,
                groupBy: EmptyString
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">Daily Transaction Report</span>
            </div>
            <hr />

            <div className="flex flex-col sm:flex-row gap-5 justify-between mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full flex-wrap">
                    <div className="flex flex-col gap-2 w-42">
                        <span>Date From</span>
                        <DatePicker className="w-full h-10 bg-white" value={dateFrom} onChange={dateFromChange} />
                    </div>
                    <div className="flex flex-col gap-2 w-42">
                        <span>Date To</span>
                        <DatePicker className="w-full h-10 bg-white" value={dateTo} onChange={dateToChange} />
                    </div>
                </div>
                <div>
                    <div className="flex justify-end items-end h-full">
                        <SearchButton onClick={searchBtnClick} />
                    </div>
                </div>                
            </div>

            <div className="flex gap-4 items-center justify-end">
                <span>Include Exeption</span>
                <div className="border rounded-md">
                    <button className={`px-4 py-2 bg-black rounded-md ${isToggled ? 'bg-black' : 'bg-white'}`} onClick={handleToggle}>
                        <span className={`${isToggled ? 'text-white' : 'text-black'}`}>ON</span>
                    </button>
                    <button className={`px-4 py-2 bg-black rounded-md ${isToggled ? 'bg-white' : 'bg-black'}`} onClick={handleToggle}>
                        <span className={`${isToggled ? 'text-black' : 'text-white'}`}>OFF</span>
                    </button>
                </div>
            </div>

            <div className="flex justify-end">
                <button className="flex gap-2 items-center bg-black px-4 py-2 rounded-md cursor-pointer" onClick={showSalesDetailClick}>
                    {showSalesDetail ? 
                        <HideIcon className="w-6 fill-white" /> :
                        <ShowIcon className="w-6 fill-white" />
                    }
                    <label className="text-white cursor-pointer">Sales Detail</label>
                </button>
            </div>
           
            <div className="hidden xl:block mt-2">
                <table className="w-full border bg-white text-md font-light mt-4">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell w-[400px]">EDC Name</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Location</th>
                            <th className="font-semibold text-right px-2 hidden sm:table-cell">Sales</th>
                            <th className={`font-semibold text-right px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>Sales On Us</th>
                            <th className={`font-semibold text-right px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>Sales Off Us</th>
                            <th className={`font-semibold text-right px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>Qris On Us</th>
                            <th className={`font-semibold text-right px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>Qris Off Us</th>
                        </tr>
                    </thead>
                    {transactionList?.data?.length > 0 ? 
                        <tbody className="border">
                            {transactionList?.data?.map((data, i) => {
                                return(
                                    <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                        <td className="text-center">{ data.rowNumber }</td>
                                        <td className="px-2">
                                            <span>{ data.bankCode + " - " + data.edcName }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.resellerName }</span>
                                        </td>
                                        <td className="px-2 text-right">
                                            <span className="font-semibold">Rp { money(String(Math.floor(parseFloat(data.salesVolume)))) }</span>
                                        </td>
                                        <td className={`px-2 text-right ${showSalesDetail ? 'table-cell' : 'hidden'}`}>
                                            <span>Rp { money(String(Math.floor(parseFloat(data.salesVolumeOnUs)))) }</span>
                                        </td>
                                        <td className={`px-2 text-right ${showSalesDetail ? 'table-cell' : 'hidden'}`}>
                                            <span>Rp { money(String(Math.floor(parseFloat(data.salesVolumeOffUs)))) }</span>
                                        </td>
                                        <td className={`px-2 text-right ${showSalesDetail ? 'table-cell' : 'hidden'}`}>
                                            <span>Rp { money(String(Math.floor(parseFloat(data.salesVolumeQrisOnUs)))) }</span>
                                        </td>
                                        <td className={`px-2 text-right ${showSalesDetail ? 'table-cell' : 'hidden'}`}>
                                            <span>Rp { money(String(Math.floor(parseFloat(data.salesVolumeQrisOffUs)))) }</span>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    :
                        <tbody>
                            <tr>
                                <td className="text-center" colSpan={12}>
                                    <span>No Transaction Data</span>
                                </td>
                            </tr>
                        </tbody>
                    }
                </table>
            </div>

            <div className="block xl:hidden mt-5">
                {transactionList?.data?.length > 0 ? 
                    <div className="flex flex-col gap-3">
                        {transactionList?.data?.map((data, i) => {
                            return(
                                <div className="flex flex-col border rounded-md shadow bg-white p-3">
                                    <label className="text-sm">{data.bankCode + " - " + data.edcName}</label>
                                    <label className="text-sm">{data.resellerName === EmptyString ? " - " : data.resellerName}</label>
                                    <label className="text-sm font-semibold">Rp { money(String(Math.floor(parseFloat(data.salesVolume)))) }</label>
                                </div>
                            )
                        })}
                    </div>
                :
                    <div className="text-center">
                        <span>No Transaction Data</span>
                    </div>
                }
            </div>

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}